import { Link } from "react-router-dom";
import { Form } from "../../modules/Form/Form";
import firstBackground from "../../images/firstBackground.jpg";

import s from "./homePage.module.scss";

export const HomePage = ({ t }) => {
  return (
    <>
      <section className={s.firstPart}>
        <img
          className={s.firstBackground}
          src={firstBackground}
          alt="background img"
        />
        <div className={s.firstBlockText}>
          <h1 className={s.firstBlockTitle}>OSka nieruchomości</h1>
          <h2 className={s.firstBlockSecondTitle}>{t.home.heroSubtitle}</h2>
          <div className={s.firstBlockActions}>
            <a href="#formTitle" className={s.firstBlocklink}>
              {t.home.heroButton}
            </a>
            <Link to="/about-us" className={s.firstBlockSecondaryLink}>
              {t.home.aboutButton}
            </Link>
          </div>
        </div>
      </section>
      <section className={s.secondPart}>
        <img className={s.secondBackground} alt="First Background" />
        <div id="formWrapper" className={s.formWrapper}>
          <p className={s.formTitle} id="formTitle">
            {t.home.formTitle}
          </p>
          <Form t={t} />
          <button className={s.submitBtn} type="submit" form="userForm">
            {t.home.submitButton}
          </button>
        </div>
      </section>
    </>
  );
};
